export default __webpack_public_path__ + "static/media/F5.39c2e6d7.gif";